import { render, staticRenderFns } from "./InvestigationList.vue?vue&type=template&id=0c9ff293&"
import script from "./InvestigationList.vue?vue&type=script&lang=ts&"
export * from "./InvestigationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c9ff293')) {
      api.createRecord('0c9ff293', component.options)
    } else {
      api.reload('0c9ff293', component.options)
    }
    module.hot.accept("./InvestigationList.vue?vue&type=template&id=0c9ff293&", function () {
      api.rerender('0c9ff293', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/InvestigationList.vue"
export default component.exports